/////////////////////////////////////////////////////////////////////////////////////////////
// Copyright 2026 Garmin International, Inc.
// Licensed under the Flexible and Interoperable Data Transfer (FIT) Protocol License; you
// may not use this file except in compliance with the Flexible and Interoperable Data
// Transfer (FIT) Protocol License.
/////////////////////////////////////////////////////////////////////////////////////////////
// ****WARNING****  This file is auto-generated!  Do NOT edit this file.
// Profile Version = 21.218.0Release
// Tag = production/release/21.218.0-0-g96fee6d7
/////////////////////////////////////////////////////////////////////////////////////////////

package com.garmin.fit

import com.garmin.fit.types.*
import kotlin.time.Instant

/**
 * The FIT `sport` message.
 *
 * A thin typed view over [Mesg]: the accessors below read and write the same
 * numbered fields the untyped API exposes, so nothing is hidden by using them.
 */
public open class SportMesg : Mesg {
    public constructor() : super("Sport", Profile.MesgNum.SPORT)

    public constructor(mesg: Mesg) : super(mesg)

    internal constructor(mesg: Mesg, adopt: Boolean) : super(mesg, adopt)

    /** sport. */
    public var sport: Sport?
        get() = (getFieldValue(SPORT_FIELD_NUM) as? UByte)?.let { Sport.fromValue(it) }
        set(value) = setFieldValue(SPORT_FIELD_NUM, value?.value)

    /** sub_sport. */
    public var subSport: SubSport?
        get() = (getFieldValue(SUB_SPORT_FIELD_NUM) as? UByte)?.let { SubSport.fromValue(it) }
        set(value) = setFieldValue(SUB_SPORT_FIELD_NUM, value?.value)

    /** name. */
    public var name: String?
        get() = getFieldValue(NAME_FIELD_NUM) as? String
        set(value) = setFieldValue(NAME_FIELD_NUM, value)

    public companion object {
        public const val SPORT_FIELD_NUM: UByte = 0u
        public const val SUB_SPORT_FIELD_NUM: UByte = 1u
        public const val NAME_FIELD_NUM: UByte = 3u

        /**
         * The profile definition of every field of this message, with no values.
         *
         * Built once when this class is first touched, and handed out only as
         * copies, so the decoder pays for a message type it never meets nothing.
         */
        internal val PROTOTYPE_FIELDS: Map<Int, Field> = buildPrototypeFields()

        private fun buildPrototypeFields(): Map<Int, Field> {
            val fields = LinkedHashMap<Int, Field>()
            fields[0] = Field("Sport", 0u, BaseType.ENUM, 1.0, 0.0, "", false)
            fields[1] = Field("SubSport", 1u, BaseType.ENUM, 1.0, 0.0, "", false)
            fields[3] = Field("Name", 3u, BaseType.STRING, 1.0, 0.0, "", false)
            return fields
        }
    }
}
